import { render, staticRenderFns } from "./editExamDialog.vue?vue&type=template&id=2530b658&scoped=true"
import script from "./editExamDialog.vue?vue&type=script&lang=js"
export * from "./editExamDialog.vue?vue&type=script&lang=js"
import style0 from "./editExamDialog.vue?vue&type=style&index=0&id=2530b658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530b658",
  null
  
)

export default component.exports